import { getPaintings } from "../../api-route/painting.js";
import { getBanner } from "../../api-route/baner.js";
import { useEffect, useRef, useState } from "react";
import { BaseURL } from "../../config/axios";
import HeroHeader from "../../Components/hero-header-section/index.section";
import { Pagination } from "@nextui-org/react";
import Filters from '../../Components/Paintings/Filters'
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import paginationHelper from "../../helper/paginationHelper";

const Painting = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;
  const navigate = useNavigate();

  const queryParams = Object.fromEntries(searchParams.entries());

  const pagination = useRef()
  const [painting, setPainting] = useState([])
  const [texts, setTexts] = useState({ baner: [] })

  useEffect(() => {
    const get = async () => {
      const data = await getBanner(2)
      setTexts(data ? data : {})
    }
    get()
  }, []);

  useEffect(() => {
    const get = async () => {
      const data = await getPaintings({ ...queryParams })
      setPainting(data ? data.data : [])
      pagination.current = data ? Math.ceil(data.total / data.per_page) : 1
    }
    get()
  }, []);


  const handlePage = (page) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page);
    navigate({ search: `?${newParams.toString()}` }, { replace: true });
    paginationHelper()
  }

  return (
    <>
      <HeroHeader {...texts} breadcrumb={[{ slug: 'painting', name: 'تابلوها' }]} />
      <div className="container mt-5">
        {texts?.header3 && <h3 className="title text-primary mb-6">{texts?.header3}</h3>}
        {texts?.header4 && <h5 className="text-center text-red-900 mb-6">{texts?.header4}</h5>}
        <main className="overflow-hidden" dir="rtl">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 grid-cols-1 gap-3">
            <Filters {...{ handlePage, page }} route='painting' />
            {painting.map((s, i) => (
              <Link to={`/product/${s.slug}`} className="bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 overflow-hidden sm:rounded-lg" key={s.id}>
                <div className="grow w-full border-b">
                  <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                    <img placeholder='blur' blurDataURL='/images/placeholder-1.png'
                      width={100} height={100}
                      src={BaseURL + s.images[0]?.path} title={s.title}
                      alt={s.title || s.title_persian}
                      className="object-contain w-full h-full max-h-[250px]"
                    />
                  </div>
                </div>
                <div className="flex flex-col items-center p-2 w-full">
                  <h4 className="w-full  font-bold text-center line-clamp-1">
                    {s.title_persian}
                  </h4>
                  <div className="w-full py-2 text-center text-sm border-b">
                    {s.artist?.title_persian}
                  </div>
                  {!!s.year &&
                    <div className="w-full py-2 centerOfParent  gap-1 text-xs border-b">
                      {s.year}
                    </div>}
                  <button
                    className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80">
                    مشاهده
                  </button>
                </div>
              </Link>
            ))}
          </div>
          <div dir="auto" className="centerOfParent mt-4">
            {!!painting.length && pagination.current > 1 &&
              <Pagination size='sm'
                total={Math.ceil(pagination.current)}
                color="primary"
                page={Number(page)}
                onChange={handlePage}
                showControls
              />}
          </div>
        </main >
      </div >
    </>
  );
}
export default Painting;
